import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Box, Autocomplete, RadioGroup, FormControlLabel, Radio, Select, MenuItem, styled, IconButton, Typography, } from "@mui/material";
import {
  B400, BLUEBORDER } from "../../../ui-components/CustomButton";
import { Primary } from "ui-components/Buttons";
import { ReactComponent as gpsIcon } from "../../../assets/gps.svg";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useTheme } from "@emotion/react";
import CustomInputField from "../../../ui-components/formik/CustomInputField";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import { AddInvestmentForRound } from "../../../api";
import * as Yup from "yup";
import CustomLabel from "../../../ui-components/CustomLabel";
import CustomValidationText from "../../../ui-components/CustomValidationText";
import { ReactComponent as UploadDocumentsIcon } from "../../../assets/rounds_icons/upload_documents_icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/rounds_icons/delete_icon.svg";
import { Add } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "../../../assets/close_icon.svg";
import { containerRef, currencyInputProps } from "../../../utilities";
import Cookies from "js-cookie";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const AllocateUnits = ({ open, handleClose, handleSubmit, currency }) => {
  // const { id: round_id } = useParams();
  const round_id = Cookies.get("round_id")
  // const startup_id = useSelector((state) => state.startupDetails.data)?._id;
  // console.log(startup_id,"const {id: round_id} = useParams();")

  const {
    mutateAsync: addInvestmentForRoundAsync,
    isLoading: isAddingInvestmentForRound,
    status: addInvestmentForRoundStatus,
    error: addInvestmentForRoundError,
    data: addInvestmentForRoundResponse,
  } = AddInvestmentForRound();
  const [validationObj, setValidationObj] = React.useState({
    email: Yup.string().required("Email is required"),
  });
  const bankValidationSchema = Yup.object({ ...validationObj });
  const formik = useFormik({
    initialValues: {
      price_per_share: 0,
      no_of_shares: 0,
      status: "",
      // startup_id: '',
      // startup_round_id: ''
    },
    validationSchema: bankValidationSchema,
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("price_per_share[0]", values?.price_per_share);
      formData.append("no_of_shares[0]", values?.no_of_shares);
      formData.append("status[0]", values?.status);
      // formData.append("startup_id",startup_id)
      formData.append("startup_round_id", round_id);
      // addInvestmentForRoundAsync({ payload: formData })?.then(() => {
        handleClose();
      // });

      // console.log({...values, startup_id: startup_id, startup_round_id: round_id})
    },
  });

  const theme = useTheme();

  const handleChange = (e) => {
    const { name, value } = e.target;
    formik.setValues({ ...formik.values, [name]: value });
  };

  const placeholders = {
    price_per_share: "Enter price per share",
    no_of_shares: "Enter no. of shares",
    status: "Select status",
  };

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <IconButton
          sx={{ position: "absolute", top: 15, right: 20, padding: 0 }}
        >
          <CloseIcon width={40} height={40} onClick={handleClose} />
        </IconButton>
        <DialogTitle sx={{ marginInline: "" }}>
          <Typography
            sx={{
              fontSize: "1.5rem",
              fontWeight: 700,
              lineHeight: "28px",
              color: theme.palette.customColors.g300,
              paddingLeft: "0.5rem",
            }}
          >
            Move to Invested
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: 0, paddingInline: 0 }}>
          <PerfectScrollbar
          containerRef={containerRef}
            style={{
              maxHeight: "calc(-250px + 100dvh)",
              paddingInline: "2rem",
            }}
          >
            <Grid item container xs={12} columnSpacing={2}>
              <Grid item xs={12}>
                <CustomInputField
                  // margin="dense"
                  InputProps={{
                    ...currencyInputProps,
                  }}
                  label="PRICE PER SHARE"
                  name="price_per_share"
                  value={formik.values?.price_per_share}
                  onChange={handleChange}
                  fullWidth
                  placeholder={placeholders?.price_per_share}
                  sx={{ marginBottom: "0.5rem" }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomInputField
                  // margin="dense"
                  InputProps={{
                    ...currencyInputProps,
                  }}
                  label="NO. OF SHARES"
                  name="no_of_shares"
                  value={formik.values?.no_of_shares}
                  onChange={handleChange}
                  fullWidth
                  placeholder={placeholders?.no_of_shares}
                  sx={{ marginBottom: "0.5rem" }}
                />
              </Grid>
            </Grid>
          </PerfectScrollbar>
        </DialogContent>
        <DialogActions
          sx={{ paddingInline: "1.5rem", paddingBottom: "1.5rem" }}
        >
          {/* <Button onClick={handleClose}>Cancel</Button> */}
          <Primary
            type="submit"
            fullWidth
            sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
          >
            Update
          </Primary>
          {/* <B300 sx={{ background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", width: '100%' }} onClick={handleSave}>Save</B300> */}
        </DialogActions>
        {/* </Dialog> */}
      </Form>
    </FormikProvider>
  );
};

export default AllocateUnits;
